/**
 * La mayor parte del código fuente tomado de: https://github.com/lyzerk/fabric-history
 *
 * Cambios
 *
 * - Se mejora el histórico de cambios eliminando la historia hacia adelante cuando la recorrer la historia hacia atrás
 * se hace un cambio
 */

/**
 * Override the initialize function for the _historyInit();
 */
import { fabric } from 'fabric-with-gestures';

// @ts-ignore
fabric.Canvas.prototype.initHistory = function () {
  // @ts-ignore
  this._historyInit();
};

/**
 * Override the dispose function for the _historyDispose();
 */
fabric.Canvas.prototype.dispose = (function (originalFn) {
  // @ts-ignore
  return function (...args) {
    // @ts-ignore
    originalFn.call(this, ...args);
    // @ts-ignore
    this._historyDispose();
    // @ts-ignore
    return this;
  };
})(fabric.Canvas.prototype.dispose);

/**
 * Returns current state of the string of the canvas
 */
// @ts-ignore
fabric.Canvas.prototype._historyNext = function () {
  // @ts-ignore
  return JSON.stringify(this);
};

/**
 * Returns an object with fabricjs event mappings
 */
// @ts-ignore
fabric.Canvas.prototype._historyEvents = function () {
  return {
    // @ts-ignore
    'object:added': this._historySaveAction,
    // @ts-ignore
    'object:removed': this._historySaveAction,
    // @ts-ignore
    'object:modified': this._historySaveAction,
    // @ts-ignore
    'object:skewing': this._historySaveAction,
  };
};

/**
 * Initialization of the plugin
 */
// @ts-ignore
fabric.Canvas.prototype._historyInit = function () {
  // @ts-ignore
  this.historyUndo = [];
  // @ts-ignore
  this.historyRedo = [];
  // @ts-ignore
  this.present = undefined;
  // @ts-ignore
  this.extraProps = ['selectable', 'editable'];
  // @ts-ignore
  this.historyNextState = this._historyNext();
  // @ts-ignore
  this.on(this._historyEvents());
};

/**
 * Remove the custom event listeners
 */
// @ts-ignore
fabric.Canvas.prototype._historyDispose = function () {
  // @ts-ignore
  this.off(this._historyEvents());
};

/**
 * It pushes the state of the canvas into history stack
 */
// @ts-ignore
fabric.Canvas.prototype._historySaveAction = function () {
  // @ts-ignore
  if (this.historyProcessing) return;
  // @ts-ignore
  const json = this.historyNextState;
  // @ts-ignore
  this.historyUndo.push(json);
  // @ts-ignore
  this.present = json;
  // @ts-ignore
  this.historyNextState = this._historyNext();
  this.fire('history:append', { json: json });
};

/**
 * Undo to latest history.
 * Pop the latest state of the history. Re-render.
 * Also, pushes into redo history.
 */
// @ts-ignore
fabric.Canvas.prototype.undo = function (callback) {
  // The undo process will render the new states of the objects
  // Therefore, object:added and object:modified events will triggered again
  // To ignore those events, we are setting a flag.
  // @ts-ignore
  this.historyProcessing = true;

  // @ts-ignore
  const history = this.historyUndo.pop();
  if (history) {
    // Push the current state to the redo history
    // @ts-ignore
    this.historyRedo.push(this._historyNext());
    // @ts-ignore
    this.historyNextState = history;
    // @ts-ignore
    this.present = this._historyNext();
    // @ts-ignore
    this._loadHistory(history, 'history:undo', callback);
  } else {
    // @ts-ignore
    this.historyProcessing = false;
  }
};

/**
 * Redo to latest undo history.
 */
// @ts-ignore
fabric.Canvas.prototype.redo = function (callback) {
  // The undo process will render the new states of the objects
  // Therefore, object:added and object:modified events will triggered again
  // To ignore those events, we are setting a flag.
  // @ts-ignore
  this.historyProcessing = true;
  // @ts-ignore
  const history = this.historyRedo.pop();
  // @ts-ignore
  if (history && history === this.present) {
    // Every redo action is actually a new action to the undo history
    // @ts-ignore
    this.historyUndo.push(this._historyNext());
    // @ts-ignore
    this.historyNextState = history;
    // @ts-ignore
    this.present = this.historyRedo[this.historyRedo.length - 1];
    // @ts-ignore
    this._loadHistory(history, 'history:redo', callback);
  } else {
    // @ts-ignore
    this.historyProcessing = false;
    // @ts-ignore
    this.historyRedo = [];
  }
};

// @ts-ignore
fabric.Canvas.prototype._loadHistory = function (history, event, callback) {
  const that = this;

  this.loadFromJSON(history, function () {
    that.renderAll();
    that.fire(event);
    // @ts-ignore
    that.historyProcessing = false;

    if (callback && typeof callback === 'function') callback();

    // El primer objeto de la lista actúa como el overlay de la aplicación, entonces, esta configuración
    // previene que el overlay se puede mover por acción misma del usuario
    that.getObjects()[0].selectable = false;
    that.getObjects()[0].evented = false;
  });
};

/**
 * Clear undo and redo history stacks
 */
// @ts-ignore
fabric.Canvas.prototype.clearHistory = function () {
  // @ts-ignore
  this.historyUndo = [];
  // @ts-ignore
  this.historyRedo = [];
  this.fire('history:clear');
};

/**
 * Off the history
 */
// @ts-ignore
fabric.Canvas.prototype.offHistory = function () {
  // @ts-ignore
  this.historyProcessing = true;
};

/**
 * On the history
 */
// @ts-ignore
fabric.Canvas.prototype.onHistory = function () {
  // @ts-ignore
  this.historyProcessing = false;

  // @ts-ignore
  this._historySaveAction();
};
